export default __webpack_public_path__ + "static/media/menu-disabled.c6125943.png";